export default function SuccessIcon() {
    return (
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="12" cy="12.2454" r="12" fill="#0B7A75" />
            <path
                d="M6.58964 13.9347C6.11433 13.4599 6.11433 12.6892 6.58964 12.2144C7.06448 11.7391 7.83512 11.7391 8.30996 12.2144L10.3608 14.2652L15.6046 7.64741C16.0195 7.12241 16.7812 7.03335 17.3062 7.44772C17.8312 7.86256 17.9203 8.62429 17.5055 9.14932L11.4829 16.7506C11.4374 16.8204 11.3845 16.8865 11.3226 16.9479C10.8478 17.4232 10.0771 17.4232 9.60227 16.9479L6.58967 13.9353L6.58964 13.9347Z"
                fill="#F8F8F6"
            />
        </svg>
    );
}
